import { Pipe, PipeTransform } from '@angular/core';
import { Petition } from '@ncessor/shared';

@Pipe({ name: 'dateRange' })
export class DateRangePipe implements PipeTransform {
  transform(value?: Petition, ...args: unknown[]): string {
    if (!value) {
      return 'Unknown';
    }
    if (value.beginDate && value.endDate) {
      if (value.isAnnual) {
        return `${value.beginDate} — ${value.endDate}`;
      }
      return `${this.mmDd(value.beginDate)} — ${this.mmDd(value.endDate)}`;
    }
    if (value.beginDate) {
      return `From ${value.beginDate}`;
    }
    if (value.endDate) {
      return `Through ${value.endDate}`;
    }
    return `None`;
  }

  mmDd(yyyyMmDD: string) {
    return yyyyMmDD.substring(5, 10);
  }
}
